var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMultiSelect = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_687_447)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFEBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16c-1 0-2 .895-2 2s1 2 2 2h9c1.1 0 2-.9 2-2s-.9-2-2-2h-9z",
    fill: "#FF905F",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10c-1 0-2 .895-2 2s1 2 2 2h9c1.1 0 2-.9 2-2s-.9-2-2-2h-9zM10 4c-1 0-2 .895-2 2s1 2 2 2h9c1.1 0 2-.9 2-2s-.9-2-2-2h-9zM3.586 4.586v2.828h2.828V4.586H3.586zM3.414 10.414v2.829h2.829v-2.829H3.414z",
    fill: "#FF905F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.414 16.414v2.829h2.829v-2.829H3.414z",
    fill: "#FF905F",
    opacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_687_447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMultiSelect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/multi-select.0b8eeb8e1329536ebc5098370bbee65a.svg";